import { useObserver } from 'mobx-react-lite'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { UnfoldSectionIcon, Clear2Icon, SearchIcon, CloseSmallIcon } from '@core'
import { Button, Input, InputAdornment, makeStyles } from '@material-ui/core'
import { CentricTypography as Typography } from '@core/component/CentricTypography'
import classNames from 'classnames'
import TabletViewMediaQuery from '@components/Utils/TabletViewMediaQuery'

const useStyles = makeStyles(theme => ({
  searchBar: {
    width: 200,
    height: 28
  },
  input: {
    '&::placeholder': {
      fontSize: 12,
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      fontStyle: 'normal'
    }
  },
  underline: {
    '&::after': {
      borderBottom: '1px solid #cccccc',
      transform: 'none'
    },
    '&:hover': {
      '&::after': {
        borderBottom: '2px solid #cccccc',
        transform: 'none'
      }
    },
    '&:focus': {
      '&::after': {
        borderBottom: '2px solid #cccccc',
        transform: 'none'
      }
    }
  },
  filterTopBar: {
    display: 'flex',
    justifyContent: 'space-between',
    height: 50,
    padding: '6px 15px'
  },
  rightIconsContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  },
  icons: {
    display: 'flex',
    alignItems: 'center',
    marginRight: '8px',
    cursor: 'pointer'
  },
  cursor: {
    cursor: 'pointer'
  },
  hiddenBtn: {
    display: 'none',
    width: 0,
    height: 0
  },
  clearAllIcon: {
    color: theme.palette.text.disabled
  },
  disabled: {
    pointerEvents: 'none'
  }
}))

export const CNFProductFilterTopBar = ({
  clearAllFilter,
  handleFilterExpansion,
  onSearchKeyChange,
  filterSearchKey,
  hasFilters
}) => {
  return useObserver(function useHook() {
    const { t } = useTranslation()
    const classes = useStyles()

    return (
      <>
        <TabletViewMediaQuery>
          {isTablet => (
            <div className={classes.filterTopBar}>
              {isTablet ? <Button className={classes.hiddenBtn} /> : null}
              <Input
                placeholder={t(
                  'common.label.searchFilterFields',
                  'Search Filter Fields...'
                )}
                value={filterSearchKey}
                startAdornment={
                  <InputAdornment position='start'>
                    <SearchIcon />
                  </InputAdornment>
                }
                endAdornment={
                  filterSearchKey && (
                    <InputAdornment position='end'>
                      <CloseSmallIcon
                        onClick={() => onSearchKeyChange('')}
                        className={classes.cursor}
                      />
                    </InputAdornment>
                  )
                }
                classes={{ input: classes.input, underline: classes.underline }}
                onChange={e => onSearchKeyChange(e.target.value)}
                className={classes.searchBar}
              />
              <div className={classes.rightIconsContainer}>
                <div className={classes.icons} onClick={handleFilterExpansion}>
                  <UnfoldSectionIcon />
                </div>
                <div
                  className={classNames(classes.icons, !hasFilters && classes.disabled)}
                  onClick={clearAllFilter}
                >
                  <Clear2Icon className={!hasFilters ? classes.clearAllIcon : ''} />
                  <Typography
                    variant={hasFilters ? 'captionDarkGrey' : 'captionLightGrey'}
                  >
                    {t('common.label.clearAll', 'Clear All')}
                  </Typography>
                </div>
              </div>
            </div>
          )}
        </TabletViewMediaQuery>
      </>
    )
  })
}
